import React, {Component} from 'react'
import {Wrapper} from './components/Styled'
import {NavLink, withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

class PuppySeekerNav extends Component {
    static defaultProps = {
      cms: {}
    }

    static propTypes = {
      cms: PropTypes.object.isRequired,
      history: PropTypes.object.isRequired,
      location: PropTypes.object.isRequired
    }

    constructor (props) {
      super(props)
      this.state = {value: this.props.location.pathname}
    }

    onChange = e => {
      this.props.history.push(`${e.target.value}`)
    }

    removeHTMLtags (string) {
      let regex = /(<([^>]+)>)/ig
      return string ? string.replace(regex, '') : ''
    }

    render () {
      return (
        <Wrapper>
          <div className='anchored-nav bgc-blue anchored-nav--light'>
            <div className='show-at-medium'>
              <div className='flex toggle-wrap flex-center'>
                <NavLink activeClassName='toggled' className='anchored-nav__anchor text-white px3 ' to='/about-akc-marketplace'>
                  { this.removeHTMLtags(this.props.cms['puppy-pages-nav-item-1']) }
                </NavLink>
                <NavLink activeClassName='toggled' className='anchored-nav__anchor text-white px3 ' to='/things-to-consider-before-getting-a-dog'>
                  { this.removeHTMLtags(this.props.cms['puppy-pages-nav-item-2']) }
                </NavLink>
                <NavLink activeClassName='toggled' className='anchored-nav__anchor text-white px3 ' to='/choosing-a-breed'>
                  { this.removeHTMLtags(this.props.cms['puppy-pages-nav-item-3']) }
                </NavLink>
                <NavLink activeClassName='toggled' className='anchored-nav__anchor text-white px3 ' to='/questions-to-ask-breeder'>
                  { this.removeHTMLtags(this.props.cms['puppy-pages-nav-item-4']) }
                </NavLink>
                <NavLink activeClassName='toggled' className='anchored-nav__anchor text-white px3 ' to='/preparing-for-puppy'>
                  { this.removeHTMLtags(this.props.cms['puppy-pages-nav-item-5']) }
                </NavLink>
              </div>
            </div>

            <div className='hide-at-medium'>
              <select className='custom-select__select minimal' id='landing_page_nav' name='landing_page_nav' placeholder='' value={this.state.value} onChange={this.onChange} >
                <option value='/about-akc-marketplace'>{ this.removeHTMLtags(this.props.cms['puppy-pages-nav-item-1']).toUpperCase() }</option>
                <option value='/things-to-consider-before-getting-a-dog'>{ this.removeHTMLtags(this.props.cms['puppy-pages-nav-item-2']).toUpperCase() }</option>
                <option value='/choosing-a-breed'>{ this.removeHTMLtags(this.props.cms['puppy-pages-nav-item-3']).toUpperCase() }</option>
                <option value='/questions-to-ask-breeder'>{ this.removeHTMLtags(this.props.cms['puppy-pages-nav-item-4']).toUpperCase() }</option>
                <option value='/preparing-for-puppy'>{ this.removeHTMLtags(this.props.cms['puppy-pages-nav-item-5']).toUpperCase() }</option>
              </select>
            </div>
          </div>
        </Wrapper>
      )
    }
}

const mapStateToProps = state => ({
  cms: state.app.cms
})

export default connect(
  mapStateToProps,
  null
)(withRouter(PuppySeekerNav))
